<script lang="ts" setup>
  import Message from 'primevue/message'
  import SpinnerDefault from '@/elements/SpinnerDefault.vue'
</script>

<template>
  <Message
    :closable="false"
    severity="info">
    <div class="inline-flex items-center">
      <slot>Daten werden geladen...</slot>
      <SpinnerDefault class="ml-2" />
    </div>
  </Message>
</template>

<style scoped></style>
